import { POST } from "../../APiHelper/API"

export const getSeasonsAndCupsAPI = (archived, term, onSuccess, onError) => {
    const data = {
        archived: archived,
        term: term
    }
    POST("/api/v1/seasons_and_cups/search", data, onSuccess, onError)
}